export default "__VITE_ASSET__DIRHeNg9__"